export var CUSTOMER_WRAPUP_PROPERTY = 'require_customer_wrapup';